import { useMicVAD } from "@ricky0123/vad-react";

interface UseVoiceChatProps {
  redemptionMs: number;
  submitUserSpeechOnPause: boolean;
  onSpeechStart: () => void;
  onVADMisfire: () => void;
  onAudioEnd: (audio: Float32Array<ArrayBufferLike>) => void;
}

const useVAD = ({
  redemptionMs,
  submitUserSpeechOnPause,
  onAudioEnd,
  onSpeechStart,
  onVADMisfire,
}: UseVoiceChatProps) => {
  // Voice Audio Detection (VAD) hook
  const vad = useMicVAD({
    baseAssetPath: "/vad/",
    onnxWASMBasePath: "/vad/",
    model: "v5",
    redemptionMs,
    submitUserSpeechOnPause,
    onSpeechEnd: (audio) => onAudioEnd(audio),
    onSpeechStart: () => onSpeechStart(),
    onVADMisfire: () => onVADMisfire(),
  });

  return {
    vad,
  };
};

export default useVAD;
